var _defs, _path, _path2, _rect, _line, _rect2, _line2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.45,48.94h30.93A11.11,11.11,0,0,1,207.46,60V226.91A11.12,11.12,0,0,1,196.38,238H59.62a11.12,11.12,0,0,1-11.08-11.09V60A11.11,11.11,0,0,1,59.62,48.94H90.55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165,36.11H146.43a18.44,18.44,0,0,0-36.87,0H91.05V64.3H165Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 79.95,
    y: 175.49,
    width: 3.18,
    height: 3.18
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103.67,
    y1: 177.08,
    x2: 178.77,
    y2: 177.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 79.95,
    y: 205.36,
    width: 3.18,
    height: 3.18
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103.67,
    y1: 206.95,
    x2: 178.77,
    y2: 206.95
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "158.17 108.09 138.2 108.09 138.2 88.13 117.79 88.13 117.79 108.09 97.83 108.09 97.83 128.5 117.79 128.5 117.79 148.47 138.2 148.47 138.2 128.5 158.17 128.5 158.17 108.09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.5c48f8b47add715ff86e7b9d5633b086.svg";
export { ForwardRef as ReactComponent };